/* eslint-disable no-restricted-imports -- This file is the designated entry point for sentry imports
 * We should be importing from the global Sentry package in this package.
 * Everywhere else we should use the sentryException from this file.
 */
import { mapEnvironmentToDSN, wrapSentryForProject, sentryCodes } from '@grantstreet/sentry-multiplex'
import { isProd } from '@grantstreet/psc-environment'

const dsns = {
  // payables-fe-prod
  prod: 'https://dc73d31fd1ef4ff6a24c3d1d3b3ab14c@o168195.ingest.sentry.io/6137795',
  // payables-fe-nonprod
  nonprod: 'https://55c74568a1604d9b8656da14d70b8cc4@o168195.ingest.sentry.io/6137796',
}

// Also export the @grantstreet/sentry-multiplex way of doing things
const Sentry = wrapSentryForProject('payables-fe', {
  dsn: () => mapEnvironmentToDSN(dsns, isProd),
})
export default Sentry
export const sentryException = Sentry.captureException

export const logDynamicImportException = error => sentryException(error, {
  level: 'error',
  tags: {
    // eslint-disable-next-line camelcase
    error_code: sentryCodes.DYNAMIC_IMPORT_REJECT,
  },
})
